import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users, ShieldCheck } from "lucide-react";

export default function Directory() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/directory");
        setMembers(r.data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="directory-page" className="max-w-4xl mx-auto">
      <div className="flex items-center gap-2 text-[#E07A5F]">
        <Users size={18} />
        <p className="overline">Community Honor Directory</p>
      </div>
      <h1 className="font-serif-dl text-4xl sm:text-5xl tracking-tight mt-2">The Community</h1>
      <p className="text-[#5C5A54] mt-3 leading-relaxed max-w-2xl">
        Members who choose to be seen. Standing reflects daps kept among peers —
        an honor reputation, never a public credit score. Opt in from your
        settings to appear here — private by default, yours to share.
      </p>

      <div className="mt-10">
        {loading ? (
          <p className="text-[#5C5A54]">Loading…</p>
        ) : members.length === 0 ? (
          <div className="bg-white border border-dashed border-[#DEDBD3] rounded-lg p-12 text-center">
            <p className="font-serif-dl text-2xl text-[#5C5A54]">No members yet.</p>
            <p className="text-[#5C5A54] mt-1">Be the first — opt in from Settings.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4">
            {members.map((m) => (
              <div
                key={m.email}
                data-testid={`directory-member-${m.email}`}
                className="bg-white border border-[#DEDBD3] rounded-lg p-6 flex items-center gap-4"
              >
                {m.picture ? (
                  <img src={m.picture} alt={m.name} className="w-14 h-14 rounded-full border border-[#DEDBD3]" />
                ) : (
                  <div className="w-14 h-14 rounded-full bg-[#F0EBE1] flex items-center justify-center text-xl font-serif-dl text-[#1B4D3E]">
                    {m.name?.[0] || "?"}
                  </div>
                )}
                <div className="min-w-0 flex-1">
                  <p className="font-medium truncate">
                    {m.name} {m.is_self && <span className="text-xs text-[#A3A095]">(you)</span>}
                    {m.verification_tier === "license" && (
                      <span className="ml-1 overline px-1.5 py-0.5 rounded bg-[#1B4D3E] text-white">Licensed Pro</span>
                    )}
                    {m.verification_tier === "phone" && (
                      <span className="ml-1 overline px-1.5 py-0.5 rounded bg-[#E6F0EB] text-[#2E6B4F] border border-[#2E6B4F]/30">Verified</span>
                    )}
                  </p>
                  <p className="text-xs text-[#8A877F] truncate">{m.email}</p>
                  <div className="flex gap-3 mt-2 text-xs text-[#5C5A54]">
                    <span className="text-[#2E6B4F]">{m.honored} honored</span>
                    <span className="text-[#9C3A3A]">{m.broken} broken</span>
                    <span>{m.sealed} sealed</span>
                  </div>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-1 text-[#1B4D3E] justify-end">
                    <ShieldCheck size={14} />
                    <span className="font-serif-dl text-3xl leading-none">{m.honor_score}%</span>
                  </div>
                  <p className="overline text-[#A3A095] mt-1">Honor</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
